import {
  NotFoundError,
  NotFoundWithFiltersError,
  InternalServerError,
  NetworkError,
} from 'app/SearchPage/utils/customError'

export const getErrorType = (error): string => {
  if (error instanceof NotFoundError) {
    return 'NotFoundError'
  } else if (error instanceof NotFoundWithFiltersError) {
    return 'NotFoundWithFiltersError'
  } else if (error instanceof InternalServerError) {
    return 'InternalServerError'
  } else if (error instanceof NetworkError) {
    return 'NetworkError'
  }

  return 'UnknownError'
}
